import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { initializeTalkJsAdmin } from '../../../services/talk.chat';

class EventChat extends Component {
    async componentDidMount() {
        const inbox = await initializeTalkJsAdmin(this.props.eventId);
        this.setState({ inbox });
    }
    componentWillUnmount() {
        this.state.inbox && this.state.inbox.destroy();
    }
    render() {
        return (
            <React.Fragment>
                <div className="ckp-admin-chat" id="ckp-js-admin-chat" />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    // data: selectors.formDataSelector(state, {model: EVENTS})
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventChat);
